import { useState } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { PartnerModal, AskPurpleWidget, WhatsAppButton, DynamicBackground } from "../common";
import { getSeoForPath } from "../../constants";
import { useSeo } from "../../hooks";

export default function Layout({ children }) {
  const [partnerOpen, setPartnerOpen] = useState(false);
  const location = useLocation();

  const seo = getSeoForPath(location.pathname);
  useSeo({
    title: seo.title,
    description: seo.description,
    canonical: seo.canonical,
  });

  return (
    <DynamicBackground>
      <div className="flex min-h-screen flex-col font-sans text-slate-900" data-testid="site-root">
        <Header onPartnerClick={() => setPartnerOpen(true)} />

        <main key={location.pathname} className="flex-1 pt-24 sm:pt-28">
          {children}
        </main>

        <Footer onPartnerClick={() => setPartnerOpen(true)} />

        <PartnerModal open={partnerOpen} onOpenChange={setPartnerOpen} />
        <AskPurpleWidget />
        <WhatsAppButton />
      </div>
    </DynamicBackground>
  );
}
